// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/en/spring-load-limit/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const springLoadLimitEN: PageEntry = {
  id: "post.federbelastungsgrenze",
  locale: "en",
  slug: "spring-load-limit",
  seo: {
    title: "Glossary: Spring load limit explained simply | Dietz GmbH",
    description: "The spring load limit is the point at which a spring reaches its maximum load without suffering permanent deformation or damage. This value is crucial for determining the limits of",
  },
  type: "post",
  h1: "Glossary: Spring load limit explained simply",
  intro: "The spring load limit is the point at which a spring reaches its maximum load without suffering permanent deformation or damage. This value is crucial for determining the limits of use of a spring in a particular system. The load limit depends on various factors, including the spring material used, the design and the environmental conditions. Accurate knowledge of the spring load limit is critical to ensure safe and reliable performance of the spring over its lifetime.",
  blocks: [

  ],
};
